import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailField", "emailRadio", "codeRadio"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasEmailRadioTarget || !this.hasEmailFieldTarget) return

    const showEmail = this.emailRadioTarget.checked
    this.emailFieldTarget.classList.toggle("hidden", !showEmail)

    const input = this.emailFieldTarget.querySelector("input")
    if (input) {
      input.required = showEmail
      if (!showEmail) input.value = ""
    }
  }
}
